let loading;
export function loadRazorpay() {
    if (window.Razorpay) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.async = true;
        const timeout = setTimeout(() => fail(), 15000);
        const fail = () => {
            clearTimeout(timeout);
            script.remove();
            loading = null;
            reject(new Error('Payment window could not load. Check your connection and try again.'));
        };
        script.onload = () => {clearTimeout(timeout); window.Razorpay ? resolve() : fail();};
        script.onerror = fail;
        document.body.appendChild(script);
    });
    return loading;
}

export async function openRazorpay(options, verify, dismissed, failed) {
    await loadRazorpay();
    if (!options?.key || !options?.order_id || !Number.isInteger(options.amount) || options.amount < 100 || options.currency !== 'INR') {
        throw new Error('Payment details are unavailable. Please refresh your order.');
    }
    const checkout = new window.Razorpay({...options, handler: verify,
        modal:{...options.modal, ondismiss:dismissed}});
    checkout.on('payment.failed', failed);
    checkout.open();
    return checkout;
}
